import { call, put, takeEvery } from 'redux-saga/effects';
import GlobalRuleServices from '../../../../services/globalRuleServices';
import * as actions from '../../../actions';
import * as actionTypes from '../../../actionTypes/ActionTypes';

export default function* addGlobalRuleSaga() {
  yield takeEvery(actionTypes.GLOBAL_RULE.ADD_GLOBAL_RULE_REQUEST, addGlobalRule);
}

export function* addGlobalRule(action) {
  try {
    const response = yield call(GlobalRuleServices.add, action.payload.values);
    if (response.success) {
      yield put(actions.addGlobalRuleSuccess(response.data));
    } else {
      yield put(actions.addGlobalRuleFail(response.data));
    }
    if (action.payload?.callback) {
      action.payload?.callback(response);
    }
  } catch (error) {
    yield put(actions.addGlobalRuleFail(error));
  }
}
